import styled from 'styled-components'
import Color from '../../../../utils/color'
import LazyImage from '../../../../components/LazyImage'
import { Header, ButtonSmall } from '../../../../components/Text'
import { FLEX_CENTER_CENTER } from '../../../../utils/styles'

const IMAGE_SIZE = '90px'

export const ProductItemContainer = styled.div`
  padding: 1rem;
  border-bottom: 1px solid ${Color.CoolGrey};
`


export const ProductItem = styled.div`
  display: flex;
  width: 100%;
  height: ${IMAGE_SIZE};
`

export const ProductImageContainer = styled.div`
  width: ${IMAGE_SIZE};
  height: ${IMAGE_SIZE};
  ${FLEX_CENTER_CENTER};
  position: relative;
`

export const ProductImage = styled(LazyImage)`
  width: 100%;
  height: 100%;
`

export const QuantityBadge = styled.div`
  background: ${({ theme }) => theme.color.primary};
  color: #fff;
  font-size: 0.7rem;
  text-align: center;
  position: absolute;
  padding: 2px 1rem;
  top: 0.5rem;
  left: -1rem;
`

export const ProductInfoContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-left: 1rem;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 5px;
    background: rgba(255, 255, 255, 0.9);
    opacity: 0.5;
  }
`

export const ProductUpperRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0.5rem;
`

export const ProductName = styled(Header)`
  padding-right: 1rem;
`

export const ProductPrice = styled.div`
  font-size: 0.9rem;
  white-space: pre;
  color: ${({ theme, discounted }) => (discounted ? theme.color.accent : theme.color.primary)};
`

export const ProductDescription = styled(ButtonSmall)`
  max-height: 3rem;
`
